export const getMargin = (margin) => {
  if (margin && margin !== '') {
    return margin
  }

  return undefined
}
